/* eslint-disable react/jsx-props-no-spreading */
import Picker from '../Picker/Picker';
import { IPickerProps, PickerType, PickerUnavailableType } from '../Picker/types';
import { TCategory } from 'src/types/categories';

const fetchCategoriesUrl: string = 'v3/categories';

const LazyCategoriesPicker = ({ fetchUrl, placeholder, ...props }: IPickerProps<TCategory>): JSX.Element => {
  return (
    <Picker<TCategory>
      {...props}
      type={PickerType.LAZY}
      fetchUrl={fetchUrl || fetchCategoriesUrl}
      unavailableType={PickerUnavailableType.CATEGORY}
      emptyText="category_not_found"
      placeholder={placeholder || 'select_category'}
    />
  );
};

export default LazyCategoriesPicker;
